import { render, staticRenderFns } from "./SchoolTestUnit.vue?vue&type=template&id=017ac9e4&scoped=true&lang=pug&"
import script from "./SchoolTestUnit.vue?vue&type=script&lang=ts&"
export * from "./SchoolTestUnit.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolTestUnit.vue?vue&type=style&index=0&id=017ac9e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017ac9e4",
  null
  
)

export default component.exports